// rules/rule-0046-fracture-followup.ts
import { AdjustedLine, ModifierContext } from '../modifier-models';
import { BaseRule } from '../rule-base';

export class Rule0046FractureFollowUp extends BaseRule {
    name = '0046 fracture follow-up 50 %';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (!line.modifiers?.includes('0046')) return;

        const newUnits = line.adjustedUnits * 0.5;
        
        if (autoApply) {
            line.adjustedUnits = newUnits;
            line.trace.push('0046 x0.5');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0046',
                message: '50% reduction for fracture follow-up',
                kind: 'overwrite',
                unitsDelta: newUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        lines
            .filter(l => l.modifiers?.includes('0046'))
            .forEach(l => {
                l.adjustedUnits *= 0.5;
                l.trace.push('0046 x0.5');
            });
        return lines;
    }
}
